import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ShopInformation } from 'src/app/interfaces/common/shop-information.interface';
import { ProductListService } from 'src/app/services/common/product-list.service';
import { ShopInformationService } from 'src/app/services/common/shop-information.service';
import { ReloadService } from 'src/app/services/core/reload.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  // Store data
  dateData: any = new Date();
  hideFooter: boolean = false;
  shopInfo: ShopInformation;

  // Subscriptions
  private subGetData1: Subscription;
  private subGetData2: Subscription;
  private subGetData3: Subscription;

  // Inject
  private readonly _productList = inject(ProductListService);
  private readonly shopInfoService = inject(ShopInformationService);
  private readonly reloadService = inject(ReloadService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    // Base Data
    this.hideFooterOnCategory();
    this.getShopInfo();
    this.checkCurrentRoute();
  }

  /**
   * hideFooterOnCategory()
   */
  private hideFooterOnCategory() {
    this.subGetData2 = this._productList?.headerProductCategoryBarShow.subscribe(
      res => {
        const isCheckoutPage = this.router.url.includes('/checkout');
        if (isCheckoutPage) {
          this.hideFooter = true;
          return;
        }
        // Only hide footer if not on home page or product-list page
        const isHomePage = this.router.url === '/' || this.router.url === '';
        const isProductListPage = this.router.url.includes('/product-list');
        this.hideFooter = res && !isHomePage && !isProductListPage;
      }
    );
  }

  /**
   * checkCurrentRoute()
   */
  private checkCurrentRoute() {
    this.updateFooterVisibility();
    this.subGetData3 = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateFooterVisibility();
    });
  }

  private updateFooterVisibility() {
    const isCheckoutPage = this.router.url.includes('/checkout');
    if (isCheckoutPage) {
      this.hideFooter = true;
      return;
    }
    const isHomePage = this.router.url === '/' || this.router.url === '';
    const isProductListPage = this.router.url.includes('/product-list');
    // If on home page or product-list page, always show footer
    if (isHomePage || isProductListPage) {
      this.hideFooter = false;
    }
  }

  /**
   * HTTP HANDLE REQUEST
   * getShopInfo()
   */
  private getShopInfo() {
    this.subGetData1 = this.shopInfoService.getShopInformation().subscribe({
      next: res => {
        if (res.success) {
          this.shopInfo = res.data;
          this.reloadService?.passHeaderData(res.data);
        }
      },
      error: err => {
        console.log(err);
      }
    }
    )
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subGetData1) {
      this.subGetData1.unsubscribe();
    }
    if (this.subGetData2) {
      this.subGetData2.unsubscribe();
    }
    if (this.subGetData3) {
      this.subGetData3.unsubscribe();
    }
  }

}
